<template>
	<el-dialog :visible.sync="dialogVisible" title="样品复制" :append-to-body="true" :close-on-click-modal="false" width="450px">
		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="复制份数" prop="num">
				<el-input v-model="ruleForm.num"></el-input>
			</el-form-item>

			<el-form-item>
				<el-button @click="$refs['ruleForm'].resetFields(), (dialogVisible = false)">取消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确认</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>
</template>

<script>
import { isUnsignedInt } from '@/utils/validate'
export default {
	data() {
		return {
			dialogVisible: false,
			ruleForm: {
				num: '',
			},
			rules: {
				num: [{ required: true, trigger: 'blur', validator: isUnsignedInt }],
			},
		}
	},
	methods: {
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					this.$emit('copyNumHandle', this.ruleForm.num)
                    this.dialogVisible = false
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
	},
}
</script>

<style>
</style>